import { useNavigate } from 'react-router';
import { useTranslation } from '../i18n/I18nProvider';
import { Button, Card } from '../ui';
import { IconLock } from './icons';

/**
 * Dio portala koji traži plaćen paket.
 *
 * Razlikuje se od `LockedWorkout`: ondje je zaključan JEDAN trening iza probne
 * kvote i ekran mu zna ime. Ovdje je zaključan cijeli dio aplikacije jer
 * pretplata nije aktivna, pa nema što imenovati — samo objasniti i ponuditi
 * izlaz.
 */
export function LockedSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card data-testid="locked-section">
      <div className="flex flex-col items-center gap-4 py-6 text-center">
        <span aria-hidden="true" className="text-accent">
          <IconLock width={40} height={40} />
        </span>
        <h2 className="font-display text-[24px] font-semibold leading-tight text-ink">
          {t('trial.sectionTitle')}
        </h2>
        <p className="max-w-prose text-[14.5px] leading-relaxed text-ink-muted">
          {t('trial.sectionHelp')}
        </p>
        <Button onClick={() => void navigate('/pretplata')}>{t('empty.browsePlans')}</Button>
      </div>
    </Card>
  );
}
